import { createStyles, makeStyles } from '@material-ui/core/styles';
import { variables } from '../../../styles';

export const useStyles = makeStyles(() =>
  createStyles({
    dialog: {
      width: 900,
      maxWidth: 900,
      borderRadius: 16,
      padding: '16px 32px 32px 32px',
    },
    btn: {
      padding: 16,
    },
    subTitleRow: {
      height: 56,
      paddingTop: 16,
      paddingBottom: 16,
    },
    subTitle: {
      fontWeight: 600,
      fontSize: 18,
      color: variables.richBlack,
    },
    permanent: {
      fontWeight: 600,
      fontSize: 16,
      color: variables.richBlack,
    },
    margin: {
      marginBottom: 30,
      marginTop: 30,
    },
    formControl: {
      width: '100%',
    },
    errorMessage: {
      textAlign: 'right',
      color: variables.red,
      paddingTop: 5,
    },
    formControlInput: {
      width: '100%',
    },
    clientTitle: {
      fontWeight: 600,
      fontSize: 18,
      color: variables.richBlack,
    },
    clientsTitleRow: {
      marginBottom: 30,
    },
    option: {
      '& svg path': {
        stroke: variables.black10,
      },
      '& span': {
        marginLeft: 20,
      },
    },
    selectedOption: {
      '& svg path': {
        stroke: variables.richBlack,
      },
      '& span': {
        marginLeft: 20,
      },
    },
    input: {
      borderRadius: 8,
    },
    inputField: {
      '& .MuiOutlinedInput-input': {
        fontSize: 14,
        borderRadius: 8,
      },
      '& .MuiOutlinedInput-root': {
        borderRadius: '8px !important;',
        height: 56,
        color: variables.richBlack,
        backgroundColor: variables.greyLight,
        border: 0,

        '&:hover': {
          border: '1px solid black',
          borderRadius: 8,
        },
      },

      '& .MuiOutlinedInput-notchedOutline': {
        border: 0,
      },

      '& .Mui-focused': {
        border: 'solid 1px #0000003b',
      },
    },
    inputAdornment: {
      // opacity: '50%',
    },
    infoIcon: {
      transform: 'scale(0.9)',
    },
    warning: {
      marginBottom: 16,
      borderRadius: 16,
      padding: 16,
      backgroundColor: '#F7F9DC',
    },
    warningTitle: {
      fontWeight: 600,
      fontSize: 16,
      color: variables.richBlack,
    },
    warningText: {
      fontWeight: 400,
      fontSize: 16,
      color: variables.black50,
    },
    dialogAction: {
      marginTop: 20,
      flexDirection: 'column',
      paddingLeft: 0,
      paddingRight: 0,
      alignItems: 'flex-start',
    },
  }),
);
